import { ApplicationStep } from "@/enum/ApplicationStep";

/**
 * Maps ApplicationStep enum values to URL route segments.
 */
const stepToRouteSegment: Record<string, string> = {
  [ApplicationStep.User]: "user",
  [ApplicationStep.Context]: "context",
  [ApplicationStep.Applicant]: "applicant/main-applicant",
  [ApplicationStep.ApplicantAddress]: "applicant-address/main-applicant",
  [ApplicationStep.ApplicantID]: "applicant-id/main-applicant",
  [ApplicationStep.ApplicantCurrentMortgage]: "applicant-current-mortgage/main-applicant",
  [ApplicationStep.ApplicantEmployment]: "applicant-employment/main-applicant",
  [ApplicationStep.ApplicantAssets]: "assets/main-applicant",
  [ApplicationStep.ApplicantLiabilities]: "liabilities/main-applicant",
  [ApplicationStep.ApplicantBankingDetails]: "banking-details",
  [ApplicationStep.CoApplicant]: "applicant/co-applicant",
  [ApplicationStep.CoApplicantAddress]: "applicant-address/co-applicant",
  [ApplicationStep.CoApplicantID]: "applicant-id/co-applicant",
  [ApplicationStep.CoApplicantCurrentMortgage]: "applicant-current-mortgage/co-applicant",
  [ApplicationStep.CoApplicantEmployment]: "applicant-employment/co-applicant",
  [ApplicationStep.CoApplicantAssets]: "assets/co-applicant",
  [ApplicationStep.CoApplicantLiabilities]: "liabilities/co-applicant",
  [ApplicationStep.CoApplicantBankingDetails]: "banking-details",
  [ApplicationStep.SelfDeclaration]: "self-declaration",
  [ApplicationStep.Review]: "review",
  [ApplicationStep.Success]: "success",
};

export const getUrlStepFromApplicationStep = (step?: string): string => {
  if (!step) {
    return "user";
  }

  return stepToRouteSegment[step] ?? "user";
};
